import React from 'react';
import { useHistory } from 'react-router';
import { Box, Typography, Button } from '@material-ui/core';
import { useCampfireTheme } from '../../../../../../../../theme/useCampfireTheme';

export const TaskApprovalRAWidget = () => {
  const { theme } = useCampfireTheme();
  const history = useHistory();

  const handleNavigateToTasks = () => {
    history.push('/admin/tasks/tasks');
  };

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
        textAlign: 'center',
        height: '200px',
      }}
    >
      <Typography
        style={{
          fontSize: '16px',
          fontWeight: 600,
          color: theme.color.grey.neutral400,
          marginBottom: '8px',
        }}
      >
        Task Approvals
      </Typography>
      <Typography
        style={{
          fontSize: '14px',
          color: theme.color.grey.neutral300,
          marginBottom: '16px',
          lineHeight: '1.4',
        }}
      >
        Task approvals and reviews are now handled in the main Tasks section
      </Typography>
      <Button
        variant='contained'
        color='primary'
        onClick={handleNavigateToTasks}
        style={{
          textTransform: 'none',
          fontWeight: 500,
        }}
      >
        Go to Tasks
      </Button>
    </Box>
  );
};
